<template>

</template>

<script>
import {mapGetters} from "vuex";
import {providerConfig} from '@/components/QualityChecks/qualityCheckProviders'

export default {
    name: "CollectionQualityChecksBase",
    props: {
        collectionId: String
    },
    computed: {
        ...mapGetters({
            apiHost: 'apiHost',
            currentAccountOverview: 'currentAccountOverview',
            learnUrls: 'learnUrls'
        })
    },
    data() {
        return {
            checks: [],
            checksEnabled: []
        }
    },
    watch: {
        collectionId() {
            this.load()
        }
    },
    methods: {
        async load() {
            this.checks = await this.$api.get(`/accounts/${this.currentAccountOverview.id}/quality-checks`).then(r=>r.data)
            try {
                this.checksEnabled = await this.$api.get(`/collections/${this.collectionId}/quality-checks`).then(r=>r.data) || []
            } catch(e) {
                console.error(e)
            }
        },
        async save() {
            await this.$api.put(`/collections/${this.collectionId}/quality-checks`, {checks:this.checksEnabled})
        },
        // DEV-2885: names alone no longer identify which compliance provider a check runs against
        // now that Theta Lake can appear beside Proofpoint.
        providerLabel(check) {
            return providerConfig(check.type).label
        },
    },
    mounted() { this.load() }
}
</script>

<style scoped>

</style>
